document.addEventListener("DOMContentLoaded", function () {
  var coll = document.getElementsByClassName("collapsible-headers");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
      for (var j = 0; j < coll.length; j++) {
        if (coll[j] !== this && coll[j].classList.contains("active")) {
          coll[j].classList.remove("active");
          coll[j].nextElementSibling.style.display = "none";
          var indicator = coll[j].querySelector(".indicator");
          indicator.innerHTML = `
            <svg class="h-6 w-6 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
          `;
        }
      }
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var indicator = this.querySelector(".indicator");
      if (this.classList.contains("active")) {
        indicator.innerHTML = `
          <svg class="h-6 w-6 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path>
          </svg>
        `;
        content.style.display = "block";
      } else {
        indicator.innerHTML = `
          <svg class="h-6 w-6 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
        `;
        content.style.display = "none";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var searchIconContainers = document.querySelectorAll(
    ".search-icon-container"
  );
  var searchBarContainers = document.querySelectorAll(".search-bar-container");
  let lastScrollTop = 0;

  window.addEventListener(
    "scroll",
    function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop) {
        searchIconContainers.forEach(function (iconContainer) {
          iconContainer.classList.remove("hidden");
        });

        searchBarContainers.forEach(function (container) {
          container.classList.add("hidden");
        });
      } else {
        searchIconContainers.forEach(function (iconContainer) {
          iconContainer.classList.add("hidden");
        });

        searchBarContainers.forEach(function (container) {
          container.classList.remove("hidden");
        });
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    },
    false
  );

  searchIconContainers.forEach(function (iconContainer) {
    iconContainer.addEventListener("click", function () {
      searchIconContainers.forEach(function (iconContainer) {
        iconContainer.classList.add("hidden");
      });

      searchBarContainers.forEach(function (container) {
        container.classList.remove("hidden");
      });
    });
  });
});

// $(document).on("click",".search-delete-value-button",function() {
//   var searchIconContainers = document.querySelectorAll(
//     ".search-icon-container"
//   );
//   var searchBarContainers = document.querySelectorAll(".search-bar-container");
//   searchIconContainers.forEach(function (iconContainer) {
//     iconContainer.classList.remove("hidden");
//   });

//   searchBarContainers.forEach(function (container) {
//     container.classList.add("hidden");
//   });
// });


// $(document).on("click",".search-icon-container",function() {
//   var searchIconContainers = document.querySelectorAll(
//     ".search-icon-container"
//   );
//   var searchBarContainers = document.querySelectorAll(".search-bar-container");
//   searchIconContainers.forEach(function (iconContainer) {
//     iconContainer.classList.add("hidden");
//   });

//   searchBarContainers.forEach(function (container) {
//     container.classList.remove("hidden");
//   });
// });

function updateVideoSectionDimensions() {
  const header = document.getElementById(
    "shopify-section-sections--21607970472274__header"
  );
  let headerHeight = header.offsetHeight;

  const videoSection = document.querySelector(
    ".relative.aspect-w-1.aspect-h-1.lg\\:aspect-w-2\\.35.lg\\:aspect-h-1"
  );

  if (videoSection) {
    const windowHeight = window.innerHeight;
    const videoSectionHeight = windowHeight - headerHeight + 1;

    videoSection.style.height = `${videoSectionHeight}px`;

    const marginTopValue = headerHeight;
    videoSection.style.marginTop = `${marginTopValue}px`;
  }
}

window.addEventListener("resize", updateVideoSectionDimensions);
window.addEventListener("load", () => {
  updateVideoSectionDimensions();
});

document.addEventListener("DOMContentLoaded", function () {
  var myInterval = setInterval(function () {
     var deleteSearchValues = document.querySelectorAll(
      ".search-delete-value-button"
    );
    var searchBar = document.querySelectorAll(".search-bar");
    
    deleteSearchValues.forEach(function (button) {
      button.addEventListener("click", function () {
        searchBar.forEach(function (input) {
          input.value = "";
        });
      });
    });
  }, 1000)
 

  setTimeout(function() { 
    clearInterval(myInterval);
  }, 15000);
});

// card slider js
$('.card_slider_image').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:true,
  prevArrow: '<button class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="13px" width="13px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/> </svg></button>',
  nextArrow: '<button class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="13px" width="13px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/> </svg></button>'
});

//Size Select / Add to cart Function
document.addEventListener('DOMContentLoaded', function () {
  // Add js-initialized class to body after JS setup
  document.body.classList.add('js-initialized');

  // Dropdown and button elements
  const dropdown = document.querySelector('.relative.select-none');
  if (!dropdown) return;

  const sizeButton = dropdown.querySelector('button');
  const optionsContainer = dropdown.querySelector('div[id^="option-dropdown"]');
  const addToCartButton = document.querySelector('#addToCartButton');
  const cartDrawer = document.querySelector('#cartDrawer'); // Replace with your cart drawer selector

  // Initial texts
  const originalText = "Add to cart";
  const hoverText = "Please select size";
  let sizeSelected = null; // Track selected size

  // Initialize dropdown and Add to Cart button
  if (sizeButton) {
    sizeButton.textContent = 'select size';
  }
  if (optionsContainer) {
    optionsContainer.style.display = 'none';
  }
  addToCartButton.textContent = originalText; // Initialize Add to Cart button text

  // Toggle dropdown visibility
  if (sizeButton && optionsContainer) {
    sizeButton.addEventListener('click', () => {
      const currentDisplay = window.getComputedStyle(optionsContainer)['display'];
      optionsContainer.style.display = currentDisplay === 'none' ? 'flex' : 'none';
    });

    // Handle size selection
    optionsContainer.querySelectorAll('div').forEach(option => {
      option.addEventListener('click', () => {
        sizeSelected = option.textContent.trim();
        sizeButton.textContent = sizeSelected; // Update dropdown button text
        optionsContainer.style.display = 'none'; // Close dropdown

        // Automatically add to cart when size is selected
        addToCart();

        // Update Add to Cart button
        updateButtonState();
      });
    });
  }

  // Update Add to Cart button text
  const updateButtonState = () => {
    addToCartButton.textContent = sizeSelected ? originalText : originalText;
  };

  // Hover behavior for Add to Cart button
  addToCartButton.addEventListener('mouseenter', () => {
    if (!sizeSelected) {
      addToCartButton.textContent = hoverText;
    }
  });

  addToCartButton.addEventListener('mouseleave', () => {
    updateButtonState(); // Revert to Add to Cart if no size is selected
  });

  // Prevent adding to cart if size is not selected, link to dropdown
  addToCartButton.addEventListener('click', (event) => {
    if (!sizeSelected) {
      event.preventDefault(); // Prevent default action
      addToCartButton.textContent = hoverText; // Show feedback
      console.warn("Size not selected!"); // Debugging message

      // Open the dropdown to prompt the user to select a size
      if (sizeButton && optionsContainer) {
        optionsContainer.style.display = 'flex';
      }
    } else {
      console.log(`Product added to cart with size: ${sizeSelected}`);
      // Add your cart logic here (e.g., form submission or API call)
    }
  });

  // Add to Cart function
  const addToCart = () => {
    console.log(`Automatically adding product to cart with size: ${sizeSelected}`);
    // Simulate adding product to cart. Replace this with your actual cart logic.
    openCartDrawer(); // Open the cart drawer
  };

  // Open Cart Drawer function
  const openCartDrawer = () => {
    if (cartDrawer) {
      cartDrawer.style.display = 'block'; // Adjust to match your cart drawer's show logic
      console.log("Cart drawer opened!");
    }
  };

  // Remove "Added to your cart" message (if applicable)
  const removeCartMessage = () => {
    const cartMessage = document.querySelector('.added-to-cart-message'); // Replace with your message selector
    if (cartMessage) {
      cartMessage.remove();
      console.log("Removed 'Added to your cart' message.");
    }
  };

  // Ensure cart message is removed when cart drawer is opened
  cartDrawer?.addEventListener('transitionend', removeCartMessage);

  // Update Add to Cart button state on page load
  updateButtonState();
});


// addsliders to picture
document.addEventListener('DOMContentLoaded', function () {
  const pictureContainer = document.querySelector('.splide__slide.is-active img')?.parentElement;
  const sliderArrows = document.querySelectorAll('.splide__arrow');
  const bulletPointsContainer = document.querySelector('.splide__pagination');

  // Utility function to set styles
  function setElementStyles(element, styles) {
    if (element && styles) {
      Object.keys(styles).forEach((style) => {
        element.style[style] = styles[style];
      });
    }
  }

  if (pictureContainer) {
    setElementStyles(pictureContainer, {
      position: 'relative',
    });
  }

  if (sliderArrows.length === 2) {
    sliderArrows.forEach((arrow) => {
      // Reduce size by 25% and add padding
      arrow.style.transform = 'scale(0.75)';
      arrow.style.padding = '5px';
    });

    setElementStyles(sliderArrows[0], {
      position: 'absolute',
      top: '50%',
      left: '10px',
      transform: 'translateY(-50%) scale(0.75)',
    });
    setElementStyles(sliderArrows[1], {
      position: 'absolute',
      top: '50%',
      right: '10px',
      transform: 'translateY(-50%) scale(0.75)',
    });
  }

  if (bulletPointsContainer) {
    setElementStyles(bulletPointsContainer, {
      position: 'absolute',
      bottom: '20px', // Raised bullet points
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '5px',
    });
  }
});

